export function numder_in(number) {
  let livesearchInput = document.getElementById('livesearchInput');
  if (number.length >= 1) {
    livesearchInput.disabled = false;
  } else {
    livesearchInput.disabled = true;
  }
}

export function fixedEncodeURIComponent(str) {
  return encodeURIComponent(str).replace(/[!'()*]/g, (c) => `%${c.charCodeAt(0).toString(16).toUpperCase()}`);
}

export function ifMaterials(check) {
  let rzNumber = document.querySelector("[name='rzNumber']");
  if (check == 1) {
    rzNumber.disabled = false;
    rzNumber.min = '1';
  } else {
    rzNumber.disabled = true;
    rzNumber.min = '';
    rzNumber.value = '';
  }
}
